import {Component, inject, signal} from '@angular/core';
import {ModalContainerComponent} from '../modal-container/modal-container.component';
import {NgbAlert} from '@ng-bootstrap/ng-bootstrap';
import {EmailConfirmIconComponent} from '@core/svg-icons/email-confirm-icon.component';
import {LoadingComponent} from '@layout/components/general/loading/loading.component';
import {UserService} from '@core/services/user.service';
import {SadWineglassIconComponent} from '@layout/components/general/sad-wineglass-icon/sad-wineglass-icon.component';

@Component({
  selector: 'app-create-password-link-error-modal',
  templateUrl: './create-password-link-error-modal.component.html',
  styleUrls: ['./create-password-link-error-modal.component.scss'],
  imports: [
    ModalContainerComponent,
    EmailConfirmIconComponent,
    LoadingComponent,
    SadWineglassIconComponent,
    NgbAlert
  ]
})
export class CreatePasswordLinkErrorModalComponent {
  private userService = inject(UserService);

  email = '';
  hasSendEmail = signal(false);
  loading = signal(false);
  errorText = '';

  sendResetPasswordEmail() {
    this.loading.set(true);
    this.userService.sendResetPasswordEmailCode(this.email).then(x => {
      this.loading.set(false);
      this.hasSendEmail.set(true);
    }).catch(() => {
      this.loading.set(false);
    });
  }

}
